export const deBridgeReferralCode = '30250';
